import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { dates } from "@/lib/dates";
import { guacHttpClient } from "@/lib/http";
import { CalendarAndTasksData, HttpResponse } from "@/types";

export const calendarWeekQueryKey = (startDate: string, endDate: string) =>
  ["calendar-and-tasks", startDate, endDate] as const;

export function useGetCalendarWeek(weekStart: Date) {
  const { startDate, endDate } = dates.weekWindow(weekStart);

  return useQuery({
    queryKey: calendarWeekQueryKey(startDate, endDate),
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = new URLSearchParams();
      params.set("startDate", startDate);
      params.set("endDate", endDate);
      const path = `dashboard/calendar-and-tasks?${params.toString()}`;
      const res = await guacHttpClient.get<
        CalendarAndTasksData,
        HttpResponse<CalendarAndTasksData>
      >(path);

      return res.data;
    },
  });
}
